// components/CoverageStatus.js
import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Box, Typography } from "@mui/material";
import instance from "../../globals/axios";
import { useAlert } from "../Alert";
import { useTranslation } from "react-i18next";
import { isNotNullOrEmptyArray } from "../../globals/utils";
import { useParams } from "react-router-dom";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import axios from "axios";

const CoverageStatus = () => {
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const { access_key } = useParams();
  const isReport = !!access_key;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response;
        if (isReport) {
          const url = `${SERVER_BASE_ADDRESS}/app-admin/get-technical-coverage-stats/`;
          response = await axios.get(url, {
            headers: {
              Authorization: `Token ${access_key}`,
            },
          });
        } else {
          response = await instance.get(
            "/app-admin/get-technical-coverage-stats/"
          );
        }

        if (response?.data?.data) {
          setData(response.data.data);
        } else {
          showAlert("error", "Failed to fetch data");
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
        showAlert("error", "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Box sx={{ padding: "16px", height: "300px" }}>
      {!isReport && loading ? (
        <Typography variant="h6">{`${t("Loading")}...`}</Typography>
      ) : isNotNullOrEmptyArray(data) ? (
        <>
          <BarChart width={370} height={300} data={data}>
            <XAxis dataKey="name" />
            <YAxis
              tickFormatter={(tick) => (Number.isInteger(tick) ? tick : "")}
            />
            <Tooltip />
            <Legend />
            <Bar dataKey="done" fill="#82ca9d" isAnimationActive={!isReport} />
            <Bar
              dataKey="pending"
              fill="#8884d8"
              isAnimationActive={!isReport}
            />
          </BarChart>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography variant="h6">{t("No data available")}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default CoverageStatus;
